import { Outlet } from "react-router-dom";
// @mui
// hooks
// components
import { useSettingsContext } from "../../components/settings";
//
import Header from "./header";
import Main from "./Main";

// ----------------------------------------------------------------------

export default function HeaderOnlyLayout() {
  useSettingsContext();

  return (
    <>
      <Header fullWidth showLogo showHamburger={false} />

      <Main headerOnly>
        <Outlet />
      </Main>
    </>
  );
}
